module.exports = __webpack_public_path__ + "media/images/icons/outlined/poweroff-0c25030e659b53b097f46d209a7b1c04.svg";